import React, { Component } from 'react';
import MobilePropertiesMenu from './PropertiesMenu/MobilePropertiesMenu';
import DesktopPropertiesMenu from './PropertiesMenu/DesktopPropertiesMenu';
import GlobalControls from './GlobalControls/GlobalControls';
import { EDITOR_TOOLBAR_ID } from 'crazyEditor/core/constants/editorConstants';
import Radium from 'radium';
import styles from './ToolbarStyles';
import {ANIMATION_DURATION, STAGGER_DELAY} from '../common/firstRenderAnimationStyles';
import { connect } from 'react-redux';

const classes = require('./Toolbar.scss');

@connect(
  (state) => ({
    isQuickPreviewMode: state.editor.isQuickPreviewMode,
  })
)
@Radium
export default class Toolbar extends Component {
  render() {
    const { isQuickPreviewMode, isPreviewMode, isMobileView, isDesktopView } = this.props;
    return (
      <div className={[!isQuickPreviewMode ? classes.enterFromTop : undefined, classes.noSelect].join(' ')} id={EDITOR_TOOLBAR_ID} style={[styles.container, isPreviewMode && styles.previewMode]}>
        <GlobalControls />
        {isMobileView && !isPreviewMode &&
        <MobilePropertiesMenu />
        }
        {isDesktopView && !isPreviewMode &&
        <DesktopPropertiesMenu />
        }
      </div>
    );
  }
}
